import React,{useRef} from "react";
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from '../../../tool';

import {WizDataAuthSelect, WizAuthority} from '@/containers/common'
import {bizTypeEnum, permTypeEnum, typeEnum} from "@/containers/permissionSetting/config";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizCard, WizAntdForm, WizCol, WizSelect, WizRadio, WizButton, WizSpin} = component_tool;
let {Session} = utils_tool

const {Item} = WizAntdForm;
const {Option} = WizSelect;

const _Form = WizAntdForm.create()(({form, initialValue, onSubmit}) => {
  let {
    bizType,
    type,
    permType,
    authInfo = {},
    targetAuthInfo = {},
  } = initialValue || {}

  const _submit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if(!err) {
        onSubmit && onSubmit(values)
      }
    })
  }

  return (
    <WizAntdForm labelCol={{span: 6}} wrapperCol={{span: 15}} >
      <Item label={'业务类型'}>
        {
          form.getFieldDecorator('bizType', {
            initialValue: bizType,
            rules: [
              {required: true, message: '请选择业务类型'},
            ],
          })(
            <WizSelect placeholder='请选择业务类型'>
              {Object.keys(bizTypeEnum).map(key => <Option value={parseInt(key)}>{bizTypeEnum[key]}</Option>)}
            </WizSelect>
          )
        }
      </Item>
      <Item label={'行为类型'}>
        {
          form.getFieldDecorator('type', {
            initialValue: type,
            rules: [
              {required: true, message: '请选择行为类型'},
            ],
          })(
            <WizRadio.Group placeholder='请选择行为类型'>
              {Object.keys(typeEnum).map(key => <WizRadio value={parseInt(key)}>{typeEnum[key]}</WizRadio>)}
            </WizRadio.Group>
          )
        }
      </Item>
      <Item label={'操作权限类型'}>
        {
          form.getFieldDecorator('permType', {
            initialValue: permType,
            rules: [
              {required: true, message: '请选择操作权限类型'},
            ],
          })(
            <WizRadio.Group placeholder='请选择行为类型'>
              {Object.keys(permTypeEnum).map(key => <WizRadio key={key} value={parseInt(key)}>{permTypeEnum[key]}</WizRadio>)}
            </WizRadio.Group>
          )
        }
      </Item>
      <Item label={'添加受众'}>
        <WizCol style={{borderWidth: 1, borderColor: '#F0F2F5', borderStyle: 'solid', paddingTop: 20}}>
          {
            form.getFieldDecorator('permAuth', {initialValue: authInfo})(
              <WizDataAuthSelect modalKey={'permAuth'}/>
            )
          }
        </WizCol>
      </Item>
      <Item label={'添加管理范围'}>
        <WizCol style={{borderWidth: 1, borderColor: '#F0F2F5', borderStyle: 'solid', paddingTop: 20}}>
          {
            form.getFieldDecorator('targetPermAuth', {initialValue: targetAuthInfo})(
              <WizDataAuthSelect modalKey={'targetPermAuth'}/>
            )
          }
        </WizCol>
      </Item>
      <Item wrapperCol={{span: 12, offset: 6}}>
        <WizButton title="保存" type="primary" onClick={_submit}>保存</WizButton>
      </Item>
    </WizAntdForm>
  )
})


class PermissionSettingSave extends WizContainer {
  componentName = 'PermissionSettingSave';

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    }

    let {history} = this.props;
    if (history.location && history.location.record) {
      this.initialValue = history.location.record
      Session.set('permissionSettingInfo', this.initialValue)
    } else {
      this.initialValue = Session.get('permissionSettingInfo') || {}
    }
  }

  _componentWillMount() {

  }

  propsAndStateOnChange = {
    save: this.saveHandle.bind(this),
  }

  _render() {
    let {state, props, initialValue} = this
    let {isLoading} = state;

    return (
      <WizSpin spinning={isLoading}>
      <WizCard title={'批量设置'}>
        <_Form initialValue={initialValue} onSubmit={this._onSubmit.bind(this)}/>
      </WizCard>
      </WizSpin>
    );
  }

  _onSubmit = (data) => {
    this.setState({
      isLoading: true,
    })

    data.permAuth = this.getDataAuth(data.permAuth);
    data.targetPermAuth = this.getDataAuth(data.targetPermAuth);

    this.doAction({
      path: 'permissionSetting/save',
      payload: {
        key: "save",
        apiParams: data,
      }
    })
  }

  getDataAuth(data = {}) {
    let {orgIds, positionIds, positionCategoryIds, personIds} = data;
    let temp = {};

    if (orgIds) {
      temp.orgIds = orgIds.map(tmp => tmp.id);
    }
    if (positionIds) {
      temp.positionIds = positionIds.map(tmp => tmp.id);
    }
    if (positionCategoryIds) {
      temp.positionCategoryIds = positionCategoryIds.map(tmp => tmp.id);
    }
    if (personIds) {
      temp.personIds = personIds.map(tmp => tmp.id);
    }

    return temp;
  }

  saveHandle(nextProps, nextState) {
    nextState.isLoading = false;
    let {success = false, msg = '系统运行繁忙请稍后再试'} = nextProps?.save
    if (success) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/permissionSetting/list');
    } else {
      wizNotice.error('提交失败：' + msg);
    }
    return true;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { permissionSetting } = state;
  const save = modelUtils.getModelEntity(permissionSetting, 'save');
  return {
    save,
  }
};

export default connect(mapStateToProps)(PermissionSettingSave);
